import { Heart, Gem, Camera, ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../content/site";
import { useBooking } from "../../context/BookingContext";
import { Reveal, SectionHeading } from "./Motion";

const ICONS = { heart: Heart, gem: Gem, camera: Camera };

const ServiceCard = ({ s, i }) => {
  const { openTab } = useBooking();
  const Icon = ICONS[s.icon];
  return (
    <Reveal delay={i * 0.12} className={i === 1 ? "md:mt-16" : ""}>
      <article className="group relative h-full overflow-hidden rounded-[28px] border border-gold/20 bg-white" data-testid={`service-card-${s.id}`}>
        <div className="relative aspect-[4/3] overflow-hidden">
          <img src={s.image} alt={`${s.title} photography`} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/35 to-transparent" />
          <span className="absolute left-5 top-5 font-serif text-sm italic text-white">0{i + 1}</span>
          <span className="absolute -bottom-7 right-6 grid h-14 w-14 place-items-center rounded-full border border-gold/30 bg-cream text-gold shadow-md transition-transform duration-500 group-hover:-translate-y-1 group-hover:rotate-12">
            <Icon className="h-6 w-6" strokeWidth={1.4} />
          </span>
        </div>
        <div className="p-7 pt-9">
          <h3 className="font-serif text-3xl text-ink">{s.title}</h3>
          <p className="mt-3 text-sm leading-relaxed text-ink-soft">{s.text}</p>
          <ul className="mt-5 space-y-2">
            {s.points.map((p) => (
              <li key={p} className="flex items-center gap-3 text-[13px] text-ink">
                <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
                {p}
              </li>
            ))}
          </ul>
          <button onClick={() => openTab(s.id)} className="mt-7 inline-flex items-center gap-2 text-sm font-medium text-gold-dark" data-testid={`service-view-packages-${s.id}`}>
            View {s.title} packages
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </article>
    </Reveal>
  );
};

export const Services = () => (
  <section id="services" className="relative bg-cream-deep section-pad" data-testid="services-section">
    <div className="mx-auto max-w-[1300px]">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <SectionHeading eyebrow="What we do" title="Stories we" script="love to tell" testid="services-heading" />
        <Reveal className="max-w-sm text-sm leading-relaxed text-ink-soft">
          Traditional, candid and cinematic coverage, planned around your rituals and your families.
        </Reveal>
      </div>
      <div className="mt-16 grid gap-8 md:grid-cols-3">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.id} s={s} i={i} />
        ))}
      </div>
    </div>
  </section>
);
